<div class="disclaimer-container" [ngClass]="{ 'no-background': isGlobalDashboard() }">
	<app-icon
		class="icon"
		[name]="'figma-info-circle'"
		[color]="'var(--color-primary-1000)'"
		[lineWidth]="'0.25px'"
		[fill]="'var(--color-primary-1000)'"
	></app-icon>
	<span class="text">
		@if(hasTimezoneFeature) {
		{{ textMessage()! }} <span class="text bold">{{ localTimeZone }}</span>
		} @else {
		{{ textMessage()! }} <span class="text bold">{{ fullTimeZone }}</span>
		}
	</span>
</div>
